import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ScanLine, ListChecks } from "lucide-react";

/**
 * Sub-navigation that appears at the top of a module page (Inspection / Trucking),
 * letting users switch between the Gate In quick-entry and the Records table.
 */
export default function ModuleTabs({ module }) {
  // module: "inspection" | "trucking"
  const location = useLocation();
  const tabs = [
    { label: "Gate In", icon: ScanLine, to: `/${module}/entry` },
    { label: "Records", icon: ListChecks, to: `/${module}/records` },
  ];
  return (
    <div className="flex items-center gap-1 mb-6 -mt-2" data-testid={`module-tabs-${module}`}>
      {tabs.map((t) => {
        const active = location.pathname.startsWith(t.to);
        const Icon = t.icon;
        return (
          <Link
            key={t.to}
            to={t.to}
            data-testid={`module-tab-${module}-${t.label.toLowerCase().replace(/\s/g, "-")}`}
            className={`inline-flex items-center gap-2 px-4 py-2 text-xs font-bold uppercase tracking-[0.15em] rounded-md transition-colors ${
              active
                ? "bg-[#0a2952] text-white"
                : "bg-slate-100 text-slate-600 hover:bg-slate-200"
            }`}
          >
            <Icon size={13} /> {t.label}
          </Link>
        );
      })}
    </div>
  );
}
